import { NavigateFunction, NavigateOptions } from 'react-router-dom'
import paths from './paths'
import { RefundType } from '@/pages/Refunds/RefundsSearchPage'

export function goToHomePage(navigate: NavigateFunction, options?: NavigateOptions): void {
  navigate(paths.home, options)
}

export function goToBasicCostPage(navigate: NavigateFunction): void {
  navigate(paths.basicCost)
}

export function goToCountySettingsPage(navigate: NavigateFunction): void {
  navigate(paths.countySettings)
}

export function goToPropertyClassificationPage(navigate: NavigateFunction): void {
  navigate(paths.propertyClassification)
}

export function goToAccounts(navigate: NavigateFunction): void {
  navigate(paths.accounts)
}

export function goToLoginPage(navigate: NavigateFunction): void {
  navigate(paths.login, { replace: true })
}

export function goToMcatLoginPage(navigate: NavigateFunction): void {
  navigate(paths.mcatLogin, { replace: true })
}

export function goToAppraiserRegionsPage(navigate: NavigateFunction): void {
  navigate(paths.appraiserRegions)
}

export function goToLeaseMasterAccountsPage(navigate: NavigateFunction): void {
  navigate(paths.leaseMasterAccountsPage)
}

export function goToTelecomAccountsPage(navigate: NavigateFunction): void {
  navigate(paths.telecomAccountsPage)
}

interface GoToLeaseMasterOverviewPageParams {
  accountNumber: string
  taxYear: number
}

export function goToLeaseMasterAccountOverviewPage(
  navigate: NavigateFunction,
  params: GoToLeaseMasterOverviewPageParams,
): void {
  const leaseMasterOverviewURI = paths.leaseMasterOverviewPage.replace(
    ':accountNumber',
    params.accountNumber.toString(),
  )
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${leaseMasterOverviewURI}?${queryParams}`)
}

export function goToLeaseMasterPaymentPostingPage(navigate: NavigateFunction): void {
  navigate(paths.leaseMasterPaymentPostingPage)
}

export function goToLeaseMasterPaymentReconciliationPage(navigate: NavigateFunction): void {
  navigate(paths.leaseMasterPaymentReconciliationPage)
}

export function goToLeaseMasterAssetReconciliationPage(navigate: NavigateFunction): void {
  navigate(paths.leaseMasterAssetReconciliation)
}

export function goToMovePermitsPage(navigate: NavigateFunction): void {
  navigate(paths.movePermits)
}

export interface GoToTelecomOverviewPageParams {
  accountNumber: string
  taxYear: number
}

export function goToTelecomAccountOverviewPage(
  navigate: NavigateFunction,
  params: GoToTelecomOverviewPageParams,
): void {
  const telecomOverviewURI = paths.telecomOverviewPage.replace(':accountNumber', params.accountNumber.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${telecomOverviewURI}?${queryParams}`)
}
export interface GoToOverviewPagesParams {
  accountId: number | string
  taxYear: number
}

export function getQueryParams(taxYear?: number): string {
  const queryParams = new URLSearchParams(location.search)

  if (taxYear !== undefined && taxYear !== null) {
    queryParams.set('taxYear', taxYear.toString())
  }

  return queryParams.toString()
}

export function goToAccountOverviewPage(navigate: NavigateFunction, params: GoToOverviewPagesParams): void {
  const accountOverviewURI = paths.accountOverview.replace(':accountId', params.accountId.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${accountOverviewURI}?${queryParams}`)
}

export function goToAccountAssociatedAccountsPage(
  navigate: NavigateFunction,
  params: GoToOverviewPagesParams,
): void {
  const accountOverviewURI = paths.accountAssociatedAccounts.replace(':accountId', params.accountId.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${accountOverviewURI}?${queryParams}`)
}

export function goToAccountPropertyAssetListPage(
  navigate: NavigateFunction,
  params: GoToOverviewPagesParams,
): void {
  const accountPropertyAssetListURI = paths.accountPropertyAssetList.replace(
    ':accountId',
    params.accountId.toString(),
  )
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${accountPropertyAssetListURI}?${queryParams}`)
}

export function goToAccountPaymentsPage(navigate: NavigateFunction, params: GoToOverviewPagesParams): void {
  const accountPaymentsURI = paths.accountPayments.replace(':accountId', params.accountId.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${accountPaymentsURI}?${queryParams}`)
}

export function goToAccountDelinquencyPage(navigate: NavigateFunction, params: GoToOverviewPagesParams): void {
  const accountDelinquencyURI = paths.accountDelinquency.replace(':accountId', params.accountId.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${accountDelinquencyURI}?${queryParams}`)
}

export function goToAccountNotesPage(navigate: NavigateFunction, params: GoToOverviewPagesParams): void {
  const accountNotesURI = paths.accountNotes.replace(':accountId', params.accountId.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${accountNotesURI}?${queryParams}`)
}

export function goToAccountUsersPage(navigate: NavigateFunction, params: GoToOverviewPagesParams): void {
  const accountUsersURI = paths.accountUsers.replace(':accountId', params.accountId.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${accountUsersURI}?${queryParams}`)
}

export function goToAccountAssociatedLeaseAccountsPage(
  navigate: NavigateFunction,
  params: GoToOverviewPagesParams,
): void {
  const accountAssociatedLeaseAccountsURI = paths.accountAssociatedLeaseAccounts.replace(
    ':accountId',
    params.accountId.toString(),
  )
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${accountAssociatedLeaseAccountsURI}?${queryParams}`)
}

export function goToProfile(navigate: NavigateFunction): void {
  navigate(paths.profile)
}

export function genericNavigate(navigate: NavigateFunction, path: string): void {
  navigate(path)
}

export function goToAccountTypes(navigate: NavigateFunction): void {
  navigate(paths.accountType)
}

export function goToSicCodeMatersPage(navigate: NavigateFunction): void {
  navigate(paths.sicCodeMasters)
}
export function goToSicCodesPage(navigate: NavigateFunction): void {
  navigate(paths.sicCodes)
}

export function goToSicSiloCodesPage(navigate: NavigateFunction): void {
  navigate(paths.sicSiloCodes)
}

export function goToSubSiloCodesPage(navigate: NavigateFunction): void {
  navigate(paths.subSiloCodes)
}

export function goToUsersPage(navigate: NavigateFunction): void {
  navigate(paths.adminUsers)
}

export function goToRolesPage(navigate: NavigateFunction): void {
  navigate(paths.roles)
}

export function goToPaymentSearchPage(navigate: NavigateFunction): void {
  navigate(paths.paymentSearch)
}

export function goToPaymentSummaryPage(navigate: NavigateFunction): void {
  navigate(paths.paymentSummary)
}

export function goToPaymentReturnedPaymentPage(navigate: NavigateFunction): void {
  navigate(paths.paymentReturnedPayment)
}

export function goToPaymentDelinquentReturnedPaymentPage(navigate: NavigateFunction): void {
  navigate(paths.paymentDelinquentYear)
}

export function goToPaymentTotalsPage(navigate: NavigateFunction): void {
  navigate(paths.paymentTotals)
}

export function goToStatusReportsPage(navigate: NavigateFunction): void {
  navigate(paths.statusReport)
}

export function goToTaxAreaListPage(navigate: NavigateFunction): void {
  navigate(paths.taxAreaList)
}

export function goToAccountingReportsPage(navigate: NavigateFunction): void {
  navigate(paths.accountReports)
}

export function goToLetterAndFormReportsPage(navigate: NavigateFunction): void {
  navigate(paths.letterAndFormReports)
}

export function goToNotificationFileReportsPage(navigate: NavigateFunction): void {
  navigate(paths.notificationFileReports)
}

export function goToEmailingReportsPage(navigate: NavigateFunction): void {
  navigate(paths.emailingReports)
}

export function goToDelinquentSummaryPage(navigate: NavigateFunction): void {
  navigate(paths.delinquentSummary)
}
export function goToAppraisalRegionReportsPage(navigate: NavigateFunction): void {
  navigate(paths.appraisalRegionReports)
}

export function goToPaymentReportsPage(navigate: NavigateFunction): void {
  navigate(paths.paymentReports)
}

export function goToLeaseMasterReportsPage(navigate: NavigateFunction): void {
  navigate(paths.leaseMasterReports)
}
export interface GoToLeaseOverviewPagesParams {
  accountNumber: string
  taxYear: number
}

export function goToLeaseMasterOverviewPage(
  navigate: NavigateFunction,
  params: GoToLeaseOverviewPagesParams,
): void {
  const leaseMasterOverviewURI = paths.leaseMasterOverviewPage.replace(
    ':accountNumber',
    params.accountNumber.toString(),
  )
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${leaseMasterOverviewURI}?${queryParams}`)
}

export function goToLeaseMasterAreasPage(navigate: NavigateFunction, params: GoToLeaseOverviewPagesParams): void {
  const leaseMasterAreasURI = paths.leaseMasterAreasPage.replace(':accountNumber', params.accountNumber.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${leaseMasterAreasURI}?${queryParams}`)
}

export function goToLeaseMasterNotesPage(navigate: NavigateFunction, params: GoToLeaseOverviewPagesParams): void {
  const leaseMasterNotesURI = paths.leaseMasterNotesPage.replace(':accountNumber', params.accountNumber.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${leaseMasterNotesURI}?${queryParams}`)
}

export function goToLeaseMasterDelinquencyPage(
  navigate: NavigateFunction,
  params: GoToLeaseOverviewPagesParams,
): void {
  const leaseMasterDelinquencyURI = paths.leaseMasterDelinquencyPage.replace(
    ':accountNumber',
    params.accountNumber.toString(),
  )
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${leaseMasterDelinquencyURI}?${queryParams}`)
}

export function goToTelecomOverviewPage(navigate: NavigateFunction, params: GoToLeaseOverviewPagesParams): void {
  const telecomOverviewURI = paths.telecomOverviewPage.replace(':accountNumber', params.accountNumber.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${telecomOverviewURI}?${queryParams}`)
}

export interface GoToTelecomOverviewPagesParams {
  accountNumber: string
  taxYear: number
}

export function goToTelecomAreasPage(navigate: NavigateFunction, params: GoToTelecomOverviewPagesParams): void {
  const telecomAreasURI = paths.telecomAreasPage.replace(':accountNumber', params.accountNumber.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${telecomAreasURI}?${queryParams}`)
}

export function goToTelecomNotesPage(navigate: NavigateFunction, params: GoToTelecomOverviewPagesParams): void {
  const telecomNotesURI = paths.telecomNotesPage.replace(':accountNumber', params.accountNumber.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${telecomNotesURI}?${queryParams}`)
}

export function goToTelecomDelinquencyPage(
  navigate: NavigateFunction,
  params: GoToTelecomOverviewPagesParams,
): void {
  const telecomNotesURI = paths.telecomDelinquencyPage.replace(':accountNumber', params.accountNumber.toString())
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${telecomNotesURI}?${queryParams}`)
}

export function goToTelecomPaymentPostingPage(navigate: NavigateFunction): void {
  navigate(paths.telecomPaymentPostingPage)
}

export function goToTelecomPaymentReconciliationPage(navigate: NavigateFunction): void {
  navigate(paths.telecomPaymentReconciliationPage)
}

export interface GoToReconcilationPagesParams {
  accountId: number | string
}

function goToReconciliationRoute(
  navigate: NavigateFunction,
  path: string,
  params: GoToReconcilationPagesParams,
): void {
  const reconciliationPageURI = path.replace(':accountId', params.accountId.toString())
  const queryParams = getQueryParams()
  navigate(`${reconciliationPageURI}${queryParams ? `?${queryParams}` : ''}`)
}

export function goToReconciliationPage(navigate: NavigateFunction, params: GoToReconcilationPagesParams): void {
  goToReconciliationRoute(navigate, paths.reconciliation, params)
}

export function goToReconciliationAccountPage(
  navigate: NavigateFunction,
  params: GoToReconcilationPagesParams,
): void {
  goToReconciliationRoute(navigate, paths.reconciliationAccountInformation, params)
}

export function goToReconciliationContactsPage(
  navigate: NavigateFunction,
  params: GoToReconcilationPagesParams,
): void {
  goToReconciliationRoute(navigate, paths.reconciliationContacts, params)
}

export function goToReconciliationPropertyAssetsPage(
  navigate: NavigateFunction,
  params: GoToReconcilationPagesParams,
): void {
  goToReconciliationRoute(navigate, paths.reconciliationPropertyAssets, params)
}

export function goToReconciliationLeasedAssetsPage(
  navigate: NavigateFunction,
  params: GoToReconcilationPagesParams,
): void {
  goToReconciliationRoute(navigate, paths.reconciliationLeasedAssets, params)
}

export function goToReconciliationSummaryPage(
  navigate: NavigateFunction,
  params: GoToReconcilationPagesParams,
): void {
  goToReconciliationRoute(navigate, paths.reconciliationSummary, params)
}

export function goToDelinquentAdjustmentPage(navigate: NavigateFunction): void {
  navigate(paths.delinquentAdjustment)
}

export function goToVoidDelinquentPaymentPage(navigate: NavigateFunction): void {
  navigate(paths.voidDelinquentPayment)
}

export function goToMassPaymentsPage(navigate: NavigateFunction): void {
  navigate(paths.massPayments)
}

export function goToMasterHomePage(navigate: NavigateFunction, options?: NavigateOptions): void {
  navigate(paths.masterHome, options)
}

export function goToMasterBasicCostsPage(navigate: NavigateFunction): void {
  navigate(paths.masterBasicCost)
}

export function goToMasterAccountTypesPage(navigate: NavigateFunction): void {
  navigate(paths.masterAccountType)
}

export function goToMasterPropertyClassificationPage(navigate: NavigateFunction): void {
  navigate(paths.masterPropertyClassification)
}

export function goToDelinquentPostcardReportPage(navigate: NavigateFunction): void {
  navigate(paths.delinquentPostcardReport)
}

export function goToAccountListForPrinterReportPage(navigate: NavigateFunction): void {
  navigate(paths.accountListForPrinterReport)
}

export interface RefundBatchParams {
  id: number
}

export function goToRefundsBatchPage(navigate: NavigateFunction, params: RefundBatchParams): void {
  const refundsBatchPageURI = paths.refundsBatchWithId.replace(':id', params.id.toString())
  navigate(refundsBatchPageURI)
}

export function goToRefundsBatchSearchPage(navigate: NavigateFunction): void {
  navigate(paths.refundsBatchSearch)
}

export function goToRefundsSearchPage(navigate: NavigateFunction): void {
  navigate(paths.refundsSearch)
}

export function goToRefundsNewBatchPage(navigate: NavigateFunction, refunds: RefundType[]): void {
  navigate(paths.refundsBatch, {
    state: {
      refunds,
    },
  })
}

// Master Telecom Navigation Functions
export function goToMcatHomePage(navigate: NavigateFunction, options?: NavigateOptions): void {
  navigate(paths.mcatHome, options)
}

export function goToMcatTelecomAccountsPage(navigate: NavigateFunction): void {
  navigate(paths.mcatTelecomAccountsPage)
}

export function goToMcatTelecomMaintenancePage(navigate: NavigateFunction): void {
  navigate(paths.mcatTelecomMaintenancePage)
}

export function goToMcatTelecomOverviewPage(
  navigate: NavigateFunction,
  params: GoToTelecomOverviewPagesParams,
): void {
  const masterTelecomOverviewURI = paths.mcatTelecomOverviewPage.replace(
    ':accountNumber',
    params.accountNumber.toString(),
  )
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${masterTelecomOverviewURI}?${queryParams}`)
}

export function goToMcatTelecomAreasPage(
  navigate: NavigateFunction,
  params: GoToTelecomOverviewPagesParams,
): void {
  const masterTelecomAreasURI = paths.mcatTelecomAreasPage.replace(
    ':accountNumber',
    params.accountNumber.toString(),
  )
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${masterTelecomAreasURI}?${queryParams}`)
}

export function goToMcatTelecomNotesPage(
  navigate: NavigateFunction,
  params: GoToTelecomOverviewPagesParams,
): void {
  const masterTelecomNotesURI = paths.mcatTelecomNotesPage.replace(
    ':accountNumber',
    params.accountNumber.toString(),
  )
  const queryParams = getQueryParams(params.taxYear)

  navigate(`${masterTelecomNotesURI}?${queryParams}`)
}

export function goToEndOfYearReportsPage(navigate: NavigateFunction): void {
  navigate(paths.endOfYearReports)
}

export function goToIronCountyTaxableValueReportsPage(navigate: NavigateFunction): void {
  navigate(paths.ironCountyTaxableValueReport)
}

export function goToMassAccounts(navigate: NavigateFunction): void {
  navigate(paths.massAccounts)
}

export function goToTylerIntegrationMassAccounts(navigate: NavigateFunction): void {
  navigate(paths.tylerIntegrationMassAccounts)
}

export function goToBusinessBatchPenaltyPage(navigate: NavigateFunction): void {
  navigate(paths.businessBatchPenalty)
}

export function goToLeaseBatchPenaltyPage(navigate: NavigateFunction): void {
  navigate(paths.leaseBatchPenalty)
}

export function goToTelecomBatchPenaltyPage(navigate: NavigateFunction): void {
  navigate(paths.telecomBatchPenalty)
}

// Lookup Table Maintenance

export function goToLookupTableMaintenancePage(navigate: NavigateFunction): void {
  navigate(paths.lookupTableMaintenance)
}

export function goToLookupTableAppraiserRegionsPage(navigate: NavigateFunction): void {
  navigate(paths.lookupTableAppraiserRegions)
}

export function goToLookupTableIndustrialParksPage(navigate: NavigateFunction): void {
  navigate(paths.lookupTableIndustrialParks)
}

// Email Module

export function goToEmailBatchPage(navigate: NavigateFunction): void {
  navigate(paths.emailBatch)
}

export function goToNewEmailBatchPage(navigate: NavigateFunction): void {
  navigate(paths.emailBatchNew)
}

export interface GoToEmailBatchDetailPageParams {
  sessionId: string
}

export function goToEmailBatchDetailPage(
  navigate: NavigateFunction,
  params: GoToEmailBatchDetailPageParams,
): void {
  const url = paths.emailBatchDetail.replace(':sessionId', encodeURIComponent(params.sessionId))
  navigate(url)
}

export function goToEmailConfigurationPage(navigate: NavigateFunction): void {
  navigate(paths.emailConfiguration)
}
